import React from 'react';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="yk-footer">
      {/* Top accent line */}
      <div className="yk-footer-accent" />

      <div className="container-custom yk-footer-inner">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" style={{ alignItems: 'flex-start' }}>

          {/* Brand */}
          <div>
            <div className="yk-footer-brand">
              <img src="/yk-logo.png" alt="Yugal Kunj" className="yk-footer-logo" onError={e => { e.target.style.display = 'none'; }} />
              <span className="yk-footer-brand-name">Yugal Kunj</span>
            </div>
            <p className="yk-footer-tagline">
              Serving the community with spiritual programs, cultural events, and seva opportunities.
            </p>
          </div>

          {/* Programs */}
          <div>
            <h4 className="yk-footer-heading">Programs</h4>
            <ul className="yk-footer-links">
              {[
                { label: 'Camp', href: 'https://summercamp.harmonyyouthcenter.org/', external: true },
                { label: 'Retreat', href: '#/retreat/center' },
                { label: 'Class', href: '#/class/center' },
                { label: 'Tiffin', href: '#/tiffin/menu' },
              ].map(({ label, href, external }) => (
                <li key={label}>
                  <a href={href} className="yk-footer-link" {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                    <span className="yk-footer-dot" />
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="yk-footer-heading">Support & Contact</h4>
            <ul className="yk-footer-links">
              <li>
                <a href="https://ykportal.yugalkunj.org/home/contact" target="_blank" rel="noopener noreferrer" className="yk-footer-link">
                  <span className="yk-footer-dot" />
                  Contact Us
                </a>
              </li>
              <li className="yk-footer-contact-item">
                <span>✉</span> info@yugalkunj.org
              </li>
              <li className="yk-footer-contact-item">
                <span>📞</span> +1 (203) 887-7422
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="yk-footer-bottom">
          <p className="yk-footer-copy">
            &copy; {year} Yugal Kunj. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
